import { ReactNode } from "react";
import clsx from "../../../modules/helpers/clsx";
import { useFocusable } from "../../../modules/spatialNavigation";
import * as styles from "./styles.module.scss";

interface IProps {
  focusKey: string;
  children?: ReactNode;
  label?: string;
  disabled?: boolean;
  active?: boolean;
  filled?: boolean;
  className?: string;
  fullWidth?: boolean;
  iconType?: "filled" | "outlined";
  startIcon?: string;
  color?: "default" | "primary";
  isCentered?: boolean;
  onClick?: () => void;
  onFocus?: () => void;
}

const FocusableButton = (props: IProps) => {
  const { ref, focused } = useFocusable({
    focusKey: props.focusKey,
    onFocus: props.onFocus,
    onEnterPress: props.onClick,
  });

  return (
    <button
      ref={ref}
      disabled={props.disabled}
      onClick={props.onClick}
      className={clsx({
        [styles.hasChildren]: !!props.children,
        [styles.button]: true,
        [styles.fullWidth]: !!props.fullWidth,
        [styles.variantFilled]: !!props.filled,
        [styles[props.color]]: true,
        [styles.focused]: focused,
        [styles.active]: props.active,
        [styles.withIcon]: !!props.startIcon,
        [props.className]: !!props.className,
      })}
    >
      {props.children ? (
        props.children
      ) : (
        <span
          className={clsx({
            [styles.buttonInner]: true,
            [styles.isCentered]: !!props.isCentered,
          })}
        >
          {!!props.startIcon && (
            <span
              className={clsx({
                "mat-symbol-round-fill": !props.iconType || props.iconType === "filled",
                "mat-symbol-round": props.iconType === "outlined",
                [styles.icon]: true,
                [styles.margined]: !!props.label,
              })}
              dangerouslySetInnerHTML={{ __html: props.startIcon }}
            />
          )}
          {!!props.label && <span>{props.label}</span>}
        </span>
      )}
    </button>
  );
};

export default FocusableButton;
